var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIc16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61098 4.29289C1.98291 3.90237 2.58592 3.90237 2.95785 4.29289L7.9987 9.58579L13.0395 4.29289C13.4115 3.90237 14.0145 3.90237 14.3864 4.29289C14.7583 4.68342 14.7583 5.31658 14.3864 5.70711L8.67213 11.7071C8.30021 12.0976 7.69719 12.0976 7.32526 11.7071L1.61098 5.70711C1.23905 5.31658 1.23905 4.68342 1.61098 4.29289Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIc16X16);
export default __webpack_public_path__ + "static/media/arrow_ic_16x16.73f77368c2ff7626aa96f9d9a420e993.svg";
export { ForwardRef as ReactComponent };